import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/TextInput/TextInput.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/design/components/text-input/react'} mdxType="DeprecationBanner" />
    <p>{`TextInput is a form component to add default styling to the native text input.`}</p>
    <p><strong parentName="p">{`Note:`}</strong>{` Don't forget to set `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` to make the TextInput accessible to screen reader users.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Basic`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<TextInput aria-label="Zipcode" name="zipcode" placeholder="Zipcode" autoComplete="postal-code" />
`}</code></pre>
    <h3>{`With icons`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <TextInput
    leadingVisual={SearchIcon}
    aria-label="Zipcode"
    name="zipcode"
    placeholder="Zip"
    autoComplete="postal-code"
  />

  <TextInput
    trailingVisual={SearchIcon}
    aria-label="Zipcode"
    name="zipcode"
    placeholder="Zip"
    autoComplete="postal-code"
  />
</>
`}</code></pre>
    <h3>{`With text visuals`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <TextInput leadingVisual="$" aria-label="Cost of the thing" name="cost" placeholder="23.45" />

  <TextInput sx={{width: '150px'}} trailingVisual="minutes" aria-label="Time in minutes" name="time" placeholder="25" />
</>
`}</code></pre>
    <h3>{`With visuals and loading indicators`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const WithIconAndLoadingIndicator = () => {
  const [loading, setLoading] = React.useState(true)

  const toggleLoadingState = () => {
    setLoading(!loading)
  }

  return (
    <>
      <Box mb={6}>
        <button type="button" onClick={toggleLoadingState}>
          Toggle loading state {loading ? 'off' : 'on'}
        </button>
      </Box>

      <Text fontSize={3} mb={1} display="block">
        No visual
      </Text>
      <Box mb={3}>
        <TextInput loading={loading} />
      </Box>

      <Text fontSize={3} mb={1} display="block">
        Leading visual
      </Text>
      <Box mb={3}>
        <TextInput leadingVisual={SearchIcon} loading={loading} />
      </Box>

      <Text fontSize={3} mb={1} display="block">
        Trailing visual
      </Text>
      <Box mb={3}>
        <TextInput trailingVisual={SearchIcon} loading={loading} />
      </Box>

      <Text fontSize={3} mb={1} display="block">
        Both visuals
      </Text>
      <Box mb={3}>
        <TextInput leadingVisual={SearchIcon} trailingVisual={SearchIcon} loading={loading} />
      </Box>

      <Text fontSize={3} mb={2} display="block">
        Both visuals, position overriden
      </Text>
      <Box mb={3}>
        <TextInput loaderPosition="trailing" leadingVisual={SearchIcon} trailingVisual={SearchIcon} loading={loading} />
      </Box>
    </>
  )
}

render(<WithIconAndLoadingIndicator />)
`}</code></pre>
    <h3>{`With trailing action`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FormControl>
  <FormControl.Label>Icon action</FormControl.Label>
  <TextInput
    trailingAction={
      <TextInput.Action
        onClick={() => {
          alert('clear input')
        }}
        icon={XIcon}
        aria-label="Clear input"
        sx={{color: 'fg.subtle'}}
      />
    }
  />
</FormControl>
`}</code></pre>
    <h3>{`With tooltip direction`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FormControl>
  <FormControl.Label>Icon action</FormControl.Label>
  <TextInput
    trailingAction={
      <TextInput.Action
        onClick={() => {
          alert('clear input')
        }}
        icon={XIcon}
        aria-label="Clear input"
        tooltipDirection="nw"
        sx={{color: 'fg.subtle'}}
      />
    }
  />
</FormControl>
`}</code></pre>
    <h3>{`With error and warning states`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <TextInput
    validationStatus="error"
    aria-label="Zipcode"
    name="zipcode"
    placeholder="Error"
    autoComplete="postal-code"
  />

  <TextInput
    validationStatus="warning"
    aria-label="Zipcode"
    name="zipcode"
    placeholder="Warning"
    autoComplete="postal-code"
  />
</>
`}</code></pre>
    <h3>{`Block text input`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<TextInput block aria-label="Zipcode" name="zipcode" placeholder="560076" autoComplete="postal-code" />
`}</code></pre>
    <h3>{`Contrast text input`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<TextInput contrast aria-label="Zipcode" name="zipcode" placeholder="Find user" autoComplete="postal-code" />
`}</code></pre>
    <h3>{`Monospace text input`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<TextInput
  monospace
  aria-label="Personal access token"
  name="pat"
  leadingVisual={CheckIcon}
  placeholder="github_pat_abcdefg123456789"
/>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: true,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      